<template>
  <b-navbar toggleable="lg" type="dark">
    <router-link class="navbar-brand" to="/">IL Castello</router-link>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <router-link class="nav-link" to="/">Home</router-link>
        <router-link class="nav-link" to="/deals">Deals</router-link>
        <router-link class="nav-link" to="/menu_items">Menu Items</router-link>
        <router-link v-if="looged_in" class="nav-link" to="/orders">Orders</router-link>
        <router-link v-if="looged_in" class="nav-link" to="/favourite_items">Favourite Items</router-link>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <router-link class="nav-link" to="/cart">
          <font-awesome-icon icon="shopping-cart" />({{ cart_items_count }})
        </router-link>
        <router-link v-if="!looged_in" class="nav-link" to="/login">Login</router-link>
        <b-nav-item-dropdown v-else right>
          <template v-slot:button-content>
            {{ current_customer.name }}
          </template>
          <b-dropdown-item @click="go_to_cards">Cards</b-dropdown-item>
          <b-dropdown-item @click="go_to_profile">Profile</b-dropdown-item>
          <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    cart_items_count() {
      return this.$store.getters.cart_items_count
    },
    looged_in() {
      return this.$store.getters.logged_in
    },
    current_customer() {
      return this.$store.getters.current_customer
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("destroy_session")
      this.$router.push({ name: 'login' })
    },
    go_to_profile() {
      this.$router.push({ name: 'profile' })
    },
    go_to_cards() {
      this.$router.push({ name: 'card' })
    },
  }
}
</script>

<style scoped>
  .navbar {
    height: 8vh;
    padding-left: 100px;
    padding-right: 100px;
    background-color: #5663FF;
  }
  @media only screen and (max-width: 768px) {
    .navbar {
      padding-left: 20px;
      padding-right: 20px;
      height: auto;
    }
  }
  @media only screen and (max-width: 992px) {
    .navbar {
      height: auto;
    }
  }
</style>
